/* Pre-order: mantiene la nota oculta `_preorder` en cada linea del carrito segun el estado
   actual del producto (custom.is_preorder). La lista de lineas a corregir la da la seccion
   ch-preorder-cart-data. Corre al cargar la pagina (si hay articulos) y tras cualquier cambio
   del carrito, venga del boton que venga; el checkout espera a que termine. */
(function () {
  var script = document.currentScript;
  var nativeFetch = window.fetch.bind(window);
  var running = null;
  var dirty = false;
  var pending = [];
  var CART_WRITE = /\/cart\/(add|change|update)(\.js)?(\?|$)/;

  function applyFix(fix) {
    /* Liquid serializa item.properties como lista de pares [[clave, valor], ...] */
    var props = {};
    (fix.properties || []).forEach(function (pair) { props[pair[0]] = pair[1]; });
    if (fix.preorder) props._preorder = 'true';
    else delete props._preorder;
    return nativeFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: fix.key, quantity: fix.quantity, properties: props })
    });
  }

  function sync() {
    if (running) {
      dirty = true;
      return running;
    }
    dirty = false;
    /* Esperar a que terminen los cambios de carrito en curso antes de revisar */
    running = Promise.all(pending.map(function (p) { return p.catch(function () {}); }))
      .then(function () { return nativeFetch('/cart?section_id=ch-preorder-cart-data'); })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ch-preorder-fixes]');
        var fixes = el ? JSON.parse(el.textContent) : [];
        return fixes.reduce(function (p, fix) {
          return p.then(function () { return applyFix(fix); });
        }, Promise.resolve());
      })
      .catch(function () {})
      .then(function () {
        running = null;
        if (dirty) return sync();
      });
    return running;
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var req = nativeFetch(input, init);
    if (CART_WRITE.test(url)) {
      dirty = true;
      pending.push(req);
      var done = function () {
        pending = pending.filter(function (p) { return p !== req; });
        sync();
      };
      req.then(done, done);
    }
    return req;
  };

  /* Checkout: si hay una revision pendiente, esperarla y reenviar */
  var released = false;
  document.addEventListener('submit', function (e) {
    var form = e.target;
    var btn = e.submitter;
    var isCheckout = (btn && btn.name === 'checkout') || /\/checkout/.test(form.getAttribute('action') || '');
    if (!isCheckout || released || (!running && !dirty)) return;
    e.preventDefault();
    sync().then(function () {
      released = true;
      if (form.requestSubmit) form.requestSubmit(btn || undefined);
      else window.location.href = '/checkout';
    });
  }, true);

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href^="/checkout"]');
    if (!link || (!running && !dirty)) return;
    e.preventDefault();
    sync().then(function () { window.location.href = link.href; });
  }, true);

  if (script && parseInt(script.dataset.cartCount, 10) > 0) sync();
})();
